const getName = (name: string) => {
  const tenantId = sessionStorage.getItem('tenantId');
  const shopId = sessionStorage.getItem('shopId');

  return `${tenantId || ''}-${shopId || ''}.${name}`;
};
export const getNamedLocalStorage = (name: string): string | null => {
  if (typeof window !== 'undefined' && window.localStorage) {
    return localStorage.getItem(getName(name));
  }
  return null;
};

export const setNamedLocalStorage = (name: string, updatedResource: string) => {
  if (typeof window !== 'undefined' && window.localStorage) {
    localStorage.setItem(getName(name), updatedResource);
  }
};
